import { useMultiLanguage } from 'services';
import {
  MetamaskSnaps,
  PoweredBy,
  Wrapper,
  TandCWrapper,
  TandCLink,
} from './Footer.style';

export const FooterView = () => {
  const { translate } = useMultiLanguage();

  return (
    <>
      <Wrapper>
        <PoweredBy>{translate('poweredBy')}</PoweredBy>
        <MetamaskSnaps>MetaMask Snaps</MetamaskSnaps>

        <TandCWrapper>
          {/* <CopyText>&copy;{currentYr} NodeFortress</CopyText> */}
          <TandCLink
            href="https://wallet.nodefortress.io/terms-of-use.html"
            target="_blank"
          >
            {translate('termsOfUse')}
          </TandCLink>
          <TandCLink
            href="https://wallet.nodefortress.io/privacy-policy.html"
            target="_blank"
          >
            {translate('privacyPolicy')}
          </TandCLink>
        </TandCWrapper>
      </Wrapper>
    </>
  );
};
